import { Component, inject, Input, OnInit } from '@angular/core';
import { ScadenzeDipendentiService } from 'src/app/shared/services/scadenze-dipendenti.service';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
} from 'devextreme-angular/ui/nested';
import { ScadenzeDipendenti } from 'src/app/models/scadenze-dipendenti';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { Dipendente } from 'src/app/models/dipendente';
import moment from 'moment';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI } from 'src/app/consts/const';
import { NavigatorService } from 'src/app/shared/services/navigator.service';

@Component({
  selector: 'app-grid-scadenze-dipendenti-compact',
  templateUrl: './grid-scadenze-dipendenti-compact.component.html',
  styleUrls: ['./grid-scadenze-dipendenti-compact.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxTemplateDirective,
  ],
  standalone: true,
})
export class GridScadenzeDipendentiCompactComponent implements OnInit {
  @Input() idDipendente?: number;
  dataSource: any;
  columnResizingMode: 'widget';
  private scandenzeS = inject(ScadenzeDipendentiService);
  private dipendentiService = inject(DipendentiService);
  private parametriService = inject(ParametriService);
  private navigatorService = inject(NavigatorService);
  scadenzeDipendenti: ScadenzeDipendenti[];
  listDipendenti: Dipendente[];
  giorniPreAlertDipendente: number;

  ngOnInit(): void {
    this.loadLookUp();
    this.getParametro();
  }

  loadLookUp() {
    //Lista dei dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res;
      }
    });
  }

  getParametro() {
    this.parametriService.get(PARAMETRI_GIORNI_PRE_ALERT_ARTICOLI).subscribe({
      next: (res) => {
        this.giorniPreAlertDipendente = res.valNum;
        this.loadScadenzeDipendenti();
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore ricezione parametro', 'error');
        }
      },
    });
  }

  loadScadenzeDipendenti() {
    const oggi = new Date();
    const limite = new Date(oggi);
    limite.setDate(oggi.getDate() + this.giorniPreAlertDipendente);

    if (this.idDipendente == undefined) {
      this.scandenzeS.list().subscribe({
        next: (res) => {
          this.scadenzeDipendenti = res.filter(
            (x) => new Date(x.data) <= limite && !x.eseguito
          );
        },
        error: (err) => {
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio(
              'Errore caricamento scadenze dipendenti',
              'error',
            );
          }
        },
      });
    } else {
      this.scandenzeS.listByDipendente(this.idDipendente).subscribe({
        next: (res) => {
          this.scadenzeDipendenti = res.filter(
            (x) => new Date(x.data) <= limite && !x.eseguito
          );
        },
        error: (err) => {
          if (err?.error?.title) {
            notificaMessaggio(err.error.title, 'error');
          } else {
            notificaMessaggio(
              'Errore caricamento scadenze dipendente',
              'error',
            );
          }
        },
      });
    }
  }

  getDipendenteDisplayExpr(item) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  isScaduto(dataScadenza: Date): boolean {
    if (!dataScadenza) {
      return false;
    }
    const oggi = moment().format('YYYY-MM-DD');
    const scadenza = moment(dataScadenza).format('YYYY-MM-DD');
    return scadenza <= oggi;
  }

  isInScadenza(dataScadenza: Date): boolean {
    if (!dataScadenza) {
      return false;
    }
    const oggi = moment().format('YYYY-MM-DD');
    const diffGiorni = moment(dataScadenza).diff(moment(oggi), 'days');
    //console.log('diff giorni: ' + diffGiorni);
    return diffGiorni > 0 && diffGiorni <= this.giorniPreAlertDipendente;
  }

  goToDipendente(e){
    this.navigatorService.goToDipedenteDashboard(e.data.idDipendente);
  }
}
